import { AlertCircleIcon } from "lucide-react";
import React, { useCallback } from "react";
import Flex from "../Flex/Flex";
import { BaseMenuItem } from "./BaseMenuItem";

type Props = {
    active: boolean;
    elementId: string;
    hasIssues?: boolean;
    title: string;
    top: string | number;
    scrollElementId?: string;
};

export const VerticalNavigationMenuItem = ({ active, elementId, hasIssues, title, top, scrollElementId }: Props) => {
    const handleClick = useCallback(() => {
        const element = document.getElementById(elementId);
        const elementOffsetTop = element?.offsetTop || 0;
        const topInPixels = typeof top === "string" ? parseInt(top, 10) : top;
        if (scrollElementId) {
            const scrollElement = document.getElementById(scrollElementId);
            scrollElement?.scrollTo({ top: elementOffsetTop - topInPixels, behavior: "smooth" });
        } else {
            element?.scrollIntoView({ behavior: "smooth" });
        }
    }, [elementId, top, scrollElementId]);

    return (
        <BaseMenuItem
            active={active}
            elementId={elementId}
            title={title}
            handleItemClick={handleClick}
            trailing={
                hasIssues && (
                    <Flex color="error-600" column height={16} width={16}>
                        <AlertCircleIcon size={12} />
                    </Flex>
                )
            }
        />
    );
};
